import { useCallback } from "react";
import { useLoadingContext } from "app/contexts/LoadingContext";

/**
 * Custom hook for managing partial loading in specific containers
 * @param {string} containerId - The ID of the container element to show loading in
 * @returns {object} - Object with loading state and control functions
 */
export const usePartialLoading = (containerId) => {
  const { loadingState, showPartialLoading, hidePartialLoading } =
    useLoadingContext();

  const isLoading = loadingState.partial[containerId] || false;

  const startLoading = useCallback(() => {
    showPartialLoading(containerId);
  }, [showPartialLoading, containerId]);

  const stopLoading = useCallback(() => {
    hidePartialLoading(containerId);
  }, [hidePartialLoading, containerId]);

  return {
    isLoading,
    startLoading,
    stopLoading,
  };
};
